"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Follow = function Follow(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.503 12.632h-1.875v1.875a.625.625 0 11-1.25 0v-1.875h-1.875a.625.625 0 110-1.25h1.875V9.507a.625.625 0 111.25 0v1.875h1.875a.625.625 0 110 1.25zm-6.83 2.987c1.416.526 2.06.888 2.142 2.303a.316.316 0 01-.313.335H4.192a.316.316 0 01-.313-.335c.082-1.415.726-1.777 2.141-2.303 1.36-.504 1.825-1.003 1.904-2.238a2.96 2.96 0 01-.623-.536 2.983 2.983 0 01-.595-1.473.368.368 0 01-.045.006c-.339 0-.595-.713-.595-1.215 0-.501.174-.654.34-.654.036 0 .065.005.097.007a4.241 4.241 0 01-.125-.967c0-1.777.72-2.792 2.969-2.792 1.071 0 1.143.264 1.35.634a.645.645 0 01.404-.127c.572 0 1.215.691 1.215 2.285a4.24 4.24 0 01-.125.967c.032-.002.061-.007.097-.007.166 0 .34.153.34.654 0 .502-.256 1.215-.595 1.215a.368.368 0 01-.045-.006 2.983 2.983 0 01-.596 1.473 2.964 2.964 0 01-.623.536c.08 1.235.546 1.734 1.905 2.238z"
  }));
};

var _default = (0, _react.forwardRef)(Follow);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Follow, "Follow", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Follow.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Follow.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();